module.exports = __webpack_public_path__ + "img/chuhai.2e6f6ecf.jpg";